/**
 * @description Restrict free user to only able to use main currency
 * @type {import('./index').restrictMainCurrency}
 */
export function restrictMainCurrency(context, currencyInfo) {
  const { money_format, money_format_with_currency, currency } = currencyInfo;

  if (money_format) {
    context.app.shop.money_format = money_format;
  }

  if (money_format_with_currency) {
    context.app.shop.money_format_with_currency = money_format_with_currency;
  }

  if (currency) {
    context.app.shop.currency = currency;
  }
}
